<template>
  <nav class="modal-nav-bar navbar navbar-expand-lg navbar-light sticky-top bg-white py-3">
    <div class="container-fluid justify-content-between p-0">
      <button
        @click="closeModal"
        class="nav-button-back pe-auto border-0 bg-transparent"
      >
        <svg width="21" height="18" class="icon">
          <use xlink:href="#___icon___chevron-left-bold"></use>
        </svg>
      </button>
      <button
        @click="closeModal"
        class="nav-button-close pe-auto border-0 bg-transparent"
      >
        <svg width="21" height="21" class="icon">
          <use xlink:href="#___icon___close-x"></use>
        </svg>
      </button>
    </div>
  </nav>
</template>

<script>
export default {
  name: "NavBar",
  methods: {
    closeModal() {
      this.$emit("close");
    },
  },
};
</script>

<style scoped>
.modal-nav-bar {
  max-width: 720px;
  width: 80%;
}

@media (max-width: 700px) {
  .modal-nav-bar {
      width: 100%;
  }
}

@media (max-width: 768px) {
  .modal-nav-bar {
    padding: 15px 0px;
  }
}
</style>
